export const URL_SEARCH_KEY = "query";
export const URL_SORT_KEY = "sort";
export const URL_SORT_DIRECTION = "sortDirection";
export const URL_FILTER_KEYS_KEY = "filterKeys";
export const URL_FILTER_VALUES_KEY = "filterValues";
export const URL_FILTER_TYPES_KEY = "filterTypes";
export const URL_FILTER_TAB_KEY = "filterTab";
